import React, { Component, useContext, useEffect, useRef, useState } from 'react'
import { Content, Header, PageContainer } from '../Drawer/PageContainer'
import Scrollable from '../Shared/Edit/Scrollable'
import { callApiWithAuthorization } from '../../API/CallApi'
import Loader from '../Shared/Loader/loader'
import InnerLoader from '../Shared/Loader/InnerLoader'
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { useMsal } from "@azure/msal-react";
import { updateNode } from '../Helpers/Nodes'
import { addCustomerTaxId, cancelPlanChangeInNextPhase, cancelSeatChangeInNextPhase, chargeCustomerForInvoice, chargeCustomerForOpenInvoices, deleteCustomerPaymentMethod, deleteCustomerTaxId, getCurrentSubscriptionForOrganisation, getCurrentSubscriptionStripeDataForOrganisation, getCustomerStripeData, getNewPrice, getPaymentMethodById, updateCustomer, updateCustomerDefaultPaymentMethod, updateCustomerTaxId } from '../../API/Payment/Payment'
import CustomerCardList from '../Pricing/CustomerCardList'
import { OrganizationSubscriptionContext } from '../../Context/OrganizationSubscription/OrganizationSubscriptionContext'
import { NEW_CARD_ADDED, PAYMENT_METHOD_SELECTED, PAYMENT_METHOD_UPDATED, SET_TAX_INFO, PAYMENT_METHOD_REMOVED } from '../../Context/OrganizationSubscription/Events'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import AddNewCardDialog from '../Pricing/AddNewCardDialog'
import InvoiceList from './Invoices/InvoiceList'
import moment from 'moment'
import CancelSubscriptionDialog from './CancelSubscription/CancelSubscriptionDialog'
import UpdateExpiryDialog from '../Pricing/UpdateExpiryDialog'
import BillingInformationForm from '../Pricing/BillingInformationForm'
import { SET_BILLING_INFORMATION } from '../../Context/Pricing/Events'
import CompanyTaxInfoFields from '../Pricing/CompanyTaxInfoFields'
import { acceptedCardWithImages } from '../Pricing/AcceptedCardTypes'
import RemoveDialog from '../Shared/Remove/RemoveDialog'
import { useNavigate } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap';
import { SUBSCRIPTION_PLANS } from '../Shared/Subscription/SubscriptionInfo'
import { getNextSubscriptionPeriod } from './utils'
import { postMessageToRuntime } from '../Helpers/Runtime/runtime'
import NoAccessComponent from '../Shared/Error/NoAccess'
import SaveDialog from '../Shared/Remove/SaveDialog'
import { getSubscriptions } from '../../API/Subscription/SubscriptionHelper'

function CardRenderer({
    paymentMethod, defaultPaymentMethodId, showDelete,
    onUpdateCardClick, onSetAsPrimaryClick, onDeleteClick
}) {

    const { state, dispatch } = useContext(OrganizationSubscriptionContext);

    const date = new Date();

    const cardType = acceptedCardWithImages.find(cardImage => (
        cardImage.type.toLowerCase() === paymentMethod.card.brand?.toLowerCase()
    ));

    return (
        <div className='row mt-4'>
            <div className='col-1'>
                <img src={cardType?.src} width="100%" />
            </div>
            <div className='col'>
                <div>
                    {cardType?.type} ending in {paymentMethod.card.last4}
                </div>
                <div>
                    {paymentMethod.card.exp_month} / {paymentMethod.card.exp_year}
                    {
                        defaultPaymentMethodId === paymentMethod.id &&
                        <span>
                            &nbsp;(Primary)
                        </span>
                    }
                    {
                        (
                            date.getFullYear() > paymentMethod.card.exp_year ||
                            (
                                date.getFullYear() === paymentMethod.card.exp_year &&
                                date.getMonth() > paymentMethod.card.exp_month
                            )
                        ) &&
                        <span className='text-danger'>
                            Card expired, please update
                        </span>
                    }
                </div>
                <div className='text-primary'>
                    <span role="button" onClick={() => onUpdateCardClick(paymentMethod.id)}>Edit</span>
                    {
                        defaultPaymentMethodId !== paymentMethod.id &&
                        <>
                            &nbsp;|&nbsp;
                            <span role="button" onClick={() => onSetAsPrimaryClick(paymentMethod.id)}>
                                Set as primary
                            </span>
                        </>
                    }
                    {
                        showDelete &&
                        <>
                            &nbsp;|&nbsp;
                            <span onClick={onDeleteClick} role="button">Delete</span>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

function Subscription(props) {

    const saveBtn = useRef(null);
    const formRef = useRef(null);

    const navigate = useNavigate();

    const { state: subscriptionState, dispatch } = useContext(OrganizationSubscriptionContext);

    const context = useMsal();
    const [state, setState] = useState({
        subscriptions: [],
        currentOrganization: {},
        customerStripeInfo: {},
        nextChargeInfo: {},
        showAddNewCardDialog: false,
        stripe: {},
        loading: true,
        showCancellationDialog: false,
        cardToUpdate: "",
        showUpdateAddressDialog: false,
        showDeleteCardDialog: false,
        showCancelPlanChangeDialog: false,
        showCancelSeatChangeDialog: false,
        deletingCard: false,
        showNoAccess: false,
        invoiceToPay: ""
    });

    let defaultData = {};

    async function getData() {
        const currentOrganization = { ...props.organization }
        const [
            subscriptions, currentSubscription, customerStripeInfo,
            subscriptionStripeData
        ] = await Promise.all([
            getSubscriptions(),
            getCurrentSubscriptionForOrganisation(currentOrganization._id),
            getCustomerStripeData(currentOrganization._id),
            getCurrentSubscriptionStripeDataForOrganisation(currentOrganization._id)
        ]);
        if (
            subscriptions.status === "unauthorized" ||
            currentSubscription.status === "unauthorized" ||
            customerStripeInfo.status === "unauthorized" ||
            subscriptionStripeData.status === "unauthorized"
        ) {
            setState(prevState => ({
                ...prevState,
                showNoAccess: true,
                loading: false
            }))
            return;
        }
        let priceId = subscriptionStripeData.items.data[0].price.id;
        let quantity = subscriptionStripeData.items.data[0].quantity;
        if (subscriptionStripeData.schedule) {
            const nextPeriod = getNextSubscriptionPeriod(subscriptionStripeData);
            if (nextPeriod) {
                priceId = nextPeriod.items[0].price;
                quantity = nextPeriod.items[0].quantity;
            }
        }
        const nextChargeInfo = await getNewPrice(
            subscriptionStripeData.id, priceId, quantity
        )
        defaultData = {
            ...currentSubscription,
            numSeats: Number(currentOrganization.numSeats)
        }
        setState(prevState => ({
            ...prevState,
            subscriptions,
            currentSubscription,
            customerStripeInfo,
            numSeats: Number(currentOrganization.numSeats),
            currentOrganization,
            selectedSubscription: {},
            showSubscriptionChangeDailog: false,
            loading: false,
            showCancellationDialog: false,
            subscriptionStripeData,
            nextChargeInfo
        }));
    }

    useEffect(() => {
        getData();
    }, [])

    useEffect(() => {
        if (subscriptionState.paymentMethods.length > 0) {
            const { subscriptionStripeData } = state;
            dispatch({
                type: PAYMENT_METHOD_SELECTED,
                payload: subscriptionStripeData.default_payment_method
            })
        }
    }, [subscriptionState.paymentMethods])

    const setNumberofSeatsData = () => {
        const maxSeats = state.selectedSubscription.maxSeats
        let numSeats = []
        for (let i = 0; i < Number(maxSeats); i++) {
            numSeats.push(i + 1)
        }
        return numSeats
    }

    const toggleChangeSubscriptionDailog = () => {
        setState(prevState => ({
            ...prevState,
            showSubscriptionChangeDailog: !state.showSubscriptionChangeDailog,
            selectedSubscription: state.currentSubscription.length === 0 ? {} : state.currentSubscription
        }))
    }

    const handleSubscriptionChange = (e) => {
        let numSeats
        if (e.target.value.id !== state.currentSubscription.id) {
            numSeats = 1
        } else {
            numSeats = Number(defaultData.numSeats)
        }
        setState(prevState => ({
            ...prevState,
            selectedSubscription: e.target.value,
            numSeats
        }))
    }

    const showAddNewCardDialog = () => {
        const stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
        setState(prevState => ({
            ...prevState,
            showAddNewCardDialog: true,
            stripe
        }))
    }

    function handlePayNowClick(event, invoice) {
        debugger;
        const stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
        setState(prevState => ({
            ...prevState,
            showAddNewCardDialog: true,
            invoiceToPay: invoice.id,
            stripe
        }))
    }

    const hideAddNewCardDialog = () => {
        setState(prevState => ({
            ...prevState,
            showAddNewCardDialog: false,
            stripe: {},
            invoiceToPay: ""
        }))
    }

    const handleNumberofSeats = (e) => {
        setState(prevState => ({
            ...prevState,
            numSeats: e.target.value
        }))
    }

    const shouldDisabled = () => {
        let disable = true
        if (state.selectedSubscription && state.selectedSubscription.id) {
            disable = false
        }
        if (typeof state.currentSubscription === "object" && state.selectedSubscription.id === state.currentSubscription.id) {
            disable = true
        }
        if (defaultData.numSeats !== String(state.numSeats)) {
            disable = false
        }
        return disable
    }

    const ChangeSubscription = async (e) => {
        e.preventDefault()
        let { currentSubscription, numSeats, currentOrganization } = state
        if (typeof state.currentSubscription === "object" && state.selectedSubscription.id !== state.currentSubscription.id) {
            let response = await callApiWithAuthorization("/api/v0/ChangeSubscription", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    orgId: currentOrganization._id,
                    subscriptionId: state.selectedSubscription.id
                }),
            })
            currentSubscription = await response.json()
        }

        if (state.currentOrganization && state.currentOrganization._id && defaultData.numSeats !== String(state.numSeats)) {
            await updateNode("Organization", state.currentOrganization._id, {
                numSeats: String(state.numSeats)
            })
            numSeats = state.numSeats
        }
        defaultData = {
            ...currentSubscription,
            numSeats,
        }
        setState(prevState => ({
            ...prevState,
            currentSubscription,
            numSeats,
            selectedSubscription: {},
            showSubscriptionChangeDailog: false
        }))
    }

    async function handleCardAdd(setupIntent) {
        debugger
        const response = await getPaymentMethodById(
            state.currentOrganization._id,
            setupIntent.payment_method
        );
        if (state.invoiceToPay) {
            await chargeCustomerForInvoice(state.currentOrganization._id, state.invoiceToPay, setupIntent.payment_method);
        } else {
            await chargeCustomerForOpenInvoices(state.currentOrganization._id, setupIntent.payment_method)
        }
        dispatch({
            type: NEW_CARD_ADDED,
            payload: response
        })
        hideAddNewCardDialog();
    }

    async function cancelSubscriptionAtPeriodEnd() {
        const organizationId = state.currentOrganization._id;
        const request = await callApiWithAuthorization(
            `/api/v0/organization/${organizationId}/subscription/cancel`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    subscriptionId: state.currentOrganization.stripeSubscriptionId
                })
            }
        );
        const response = await request.json();
        window.location.reload();
    }

    function toggleUpdateExpiryDialog(paymentMethodId) {
        setState(prevState => ({
            ...prevState,
            cardToUpdate: paymentMethodId
        }))
    }

    function hideUpdateCardDialog(updatedInfo) {
        const firstTwoDigitsOfCurrentYear = new Date().getFullYear().toString().slice(0, 2);
        dispatch({
            type: PAYMENT_METHOD_UPDATED,
            payload: {
                paymentMethodId: updatedInfo.paymentMethodId,
                expiryMonth: parseInt(updatedInfo.expiryMonth),
                expiryYear: parseInt(firstTwoDigitsOfCurrentYear + updatedInfo.expiryYear),
            }
        })
        setState(prevState => ({
            ...prevState,
            cardToUpdate: ""
        }))
    }

    async function updateCustomerPrimaryCard(cardId) {
        await updateCustomerDefaultPaymentMethod(
            state.currentOrganization._id,
            cardId
        )
        setState(prevState => ({
            ...prevState,
            customerStripeInfo: {
                ...prevState.customerStripeInfo,
                invoice_settings: {
                    ...prevState.customerStripeInfo.invoice_settings,
                    default_payment_method: cardId
                }
            }
        }))
    }

    async function handleBillingInformationSubmit() {
        const { name, ...address } = subscriptionState.billingInformation;
        let nameToUpdate = name;
        if (address.country === "CA") {
            nameToUpdate = subscriptionState.taxInfo.companyName;
        }
        const { customerStripeInfo } = state;
        const newStripeInfo = { ...customerStripeInfo };
        await updateCustomer(
            state.currentOrganization._id,
            { name: nameToUpdate, address }
        );
        newStripeInfo.address = address;
        if (state.customerStripeInfo.tax_ids.data.length === 0) {
            const newTaxId = await addCustomerTaxId(
                state.currentOrganization._id,
                subscriptionState.taxInfo.gstNumber
            )
            newStripeInfo.tax_ids.data.push(newTaxId);
        } else if (
            state.customerStripeInfo.tax_ids.data[0].value !== subscriptionState.taxInfo.gstNumber
        ) {
            const newTaxId = await updateCustomerTaxId(
                state.currentOrganization._id,
                state.customerStripeInfo.tax_ids.data[0].id,
                subscriptionState.taxInfo.gstNumber
            )
            newStripeInfo.tax_ids.data[0] = newTaxId;
        } else if (
            address.country !== "CA"
        ) {
            await deleteCustomerTaxId(
                state.currentOrganization._id,
                state.customerStripeInfo.tax_ids.data[0].id
            );
            newStripeInfo.tax_ids.data = []
        }
        setState(prevState => ({
            ...prevState,
            customerStripeInfo: newStripeInfo,
            showUpdateAddressDialog: false
        }))
    }

    function toggleDeleteCardDialog() {
        setState(prevState => ({
            ...prevState,
            showDeleteCardDialog: !prevState.showDeleteCardDialog
        }));
    }

    function handleDelete(paymentMethodId) {
        toggleDeleteCardDialog();
        setState(prevState => ({
            ...prevState,
            paymentMethodToDelete: paymentMethodId
        }))
    }

    async function deleteCard() {
        setState(prevState => ({
            ...prevState,
            deletingCard: true
        }))
        const primaryCardId = state.customerStripeInfo.invoice_settings?.default_payment_method;
        const primaryCardIndex = subscriptionState.paymentMethods.findIndex(paymentMethod => (
            paymentMethod.id === primaryCardId
        ));
        await deleteCustomerPaymentMethod(state.currentOrganization._id, state.paymentMethodToDelete);
        toggleDeleteCardDialog();
        if (primaryCardId === state.paymentMethodToDelete) {
            const paymentMethods = subscriptionState.paymentMethods.filter(paymentMethod => paymentMethod.id !== state.paymentMethodToDelete);
            let nextPrimaryCardIndex = 0;
            if (primaryCardIndex !== 0) {
                nextPrimaryCardIndex = primaryCardIndex - 1;
            }
            await updateCustomerPrimaryCard(paymentMethods[nextPrimaryCardIndex].id);
        }
        dispatch({
            type: PAYMENT_METHOD_REMOVED,
            payload: state.paymentMethodToDelete
        })
        setState(prevState => ({
            ...prevState,
            paymentMethodToDelete: "",
            deletingCard: false
        }))
    }

    function navigateToPaymentPage() {
        navigate("/_Payment/" + state.currentOrganization._id)
    }

    function getPlanChangeMessage() {
        if (state.subscriptionStripeData && state.subscriptionStripeData.schedule) {
            const nextPeriod = getNextSubscriptionPeriod(state.subscriptionStripeData)
            const isPlanChanged = nextPeriod && nextPeriod.items[0].price !== state.subscriptionStripeData.items.data[0].price.id;
            if (isPlanChanged) {
                const plan = SUBSCRIPTION_PLANS.find(plan => (
                    plan.price.annually.stripePriceId === nextPeriod.items[0].price ||
                    plan.price.monthly.stripePriceId === nextPeriod.items[0].price
                ))
                const planPaymentInterval = plan.price.annually.stripePriceId === nextPeriod.items[0].price ? "Annual" : "Monthly";
                return (
                    <span>
                        (Downgrade to {plan.name} - {planPaymentInterval} when next billing cycle starts)
                        <button className='btn btn-link' onClick={toggleCancelPlanChangeDialog}>
                            Cancel Plan Change
                        </button>
                    </span>
                );
            }
        }
        return null;
    }

    function toggleCancelPlanChangeDialog() {
        setState(prevState => ({
            ...prevState,
            showCancelPlanChangeDialog: !prevState.showCancelPlanChangeDialog
        }))
    }

    async function cancelPlanChange() {
        await cancelPlanChangeInNextPhase(
            state.currentOrganization._id,
            state.currentOrganization.stripeSubscriptionId
        );

        const nextSubscriptionPeriod = getNextSubscriptionPeriod(state.subscriptionStripeData);
        nextSubscriptionPeriod.items[0].price = state.subscriptionStripeData.items.data[0].price.id;

        setState(prevState => ({
            ...prevState,
            subscriptionStripeData: {
                ...prevState.subscriptionStripeData,
                schedule: {
                    ...prevState.subscriptionStripeData.schedule,
                    phases: [
                        ...prevState.subscriptionStripeData.schedule.phases.filter(phase => (
                            phase.start_date < nextSubscriptionPeriod.start_date
                        )),
                        nextSubscriptionPeriod
                    ]
                }
            },
            showCancelPlanChangeDialog: false
        }))
    }

    function getSeatChangeMessage() {
        if (state.subscriptionStripeData && state.subscriptionStripeData.schedule) {
            const nextPeriod = getNextSubscriptionPeriod(state.subscriptionStripeData)
            const isSeatChanged = nextPeriod && nextPeriod.items[0].quantity < state.subscriptionStripeData.items.data[0].quantity;
            const isPlanChangedToFree = nextPeriod && (
                nextPeriod.items[0].price === process.env.REACT_APP_STRIPE_FREE_MONTHLY_PRICE ||
                nextPeriod.items[0].price === process.env.REACT_APP_STRIPE_FREE_ANNUAL_PRICE
            );
            const nextSubscriptionPlanDetails = nextPeriod && SUBSCRIPTION_PLANS.find(plan => (
                plan.price.annually.stripePriceId === nextPeriod.items[0].price ||
                plan.price.monthly.stripePriceId === nextPeriod.items[0].price
            ));
            const nextSubscription = nextSubscriptionPlanDetails && state.subscriptions.find(subscription => (
                subscription.stripeProductId === nextSubscriptionPlanDetails.stripeProductId
            ));
            const isNextPlanSeatLimitExceeded = nextSubscriptionPlanDetails && nextSubscription.maxSeats < state.numSeats;
            if (isSeatChanged) {
                if (isPlanChangedToFree) {
                    <span>
                        (Reduce to 2 seats when next billing cycle starts)
                    </span>
                } else if (!isPlanChangedToFree && !isNextPlanSeatLimitExceeded) {
                    return (
                        <span>
                            (Reduce to {nextPeriod.items[0].quantity} when next billing cycle starts)
                            <button className='btn btn-link' onClick={toggleCancelSeatChangeDialog}>
                                Cancel Seat Change
                            </button>
                        </span>
                    );
                }
            }
        }
        return null;
    }

    function toggleCancelSeatChangeDialog() {
        setState(prevState => ({
            ...prevState,
            showCancelSeatChangeDialog: !prevState.showCancelSeatChangeDialog
        }))
    }

    async function cancelSeatChange() {
        await cancelSeatChangeInNextPhase(
            state.currentOrganization._id,
            state.currentOrganization.stripeSubscriptionId
        );

        const nextSubscriptionPeriod = getNextSubscriptionPeriod(state.subscriptionStripeData);
        nextSubscriptionPeriod.items[0].quantity = state.subscriptionStripeData.items.data[0].quantity;

        setState(prevState => ({
            ...prevState,
            subscriptionStripeData: {
                ...prevState.subscriptionStripeData,
                schedule: {
                    ...prevState.subscriptionStripeData.schedule,
                    phases: [
                        ...prevState.subscriptionStripeData.schedule.phases.filter(phase => (
                            phase.start_date < nextSubscriptionPeriod.start_date
                        )),
                        nextSubscriptionPeriod
                    ]
                }
            },
            showCancelSeatChangeDialog: false
        }))
    }

    function sendOpenPopupMessageToRuntime() {
        postMessageToRuntime({
            eventType: "OPEN_PRICING_POPUP"
        })
    }

    if (state.showNoAccess) {
        return <NoAccessComponent />
    }

    return (
        <PageContainer>
            {
                !props.showInIframe &&
                <div className='sub'>
                    <Header
                        header="Subscription"
                        headerDescription="Explore different subscription plans for your teams"
                    ></Header>
                </div>
            }
            <Content>
                {
                    state.showCancellationDialog &&
                    <CancelSubscriptionDialog
                        endDate={
                            moment(state.subscriptionStripeData?.current_period_end * 1000).format("Do MMMM YYYY")
                        }
                        onConfirm={cancelSubscriptionAtPeriodEnd}
                        onClose={() => setState(prevState => ({
                            ...prevState,
                            showCancellationDialog: false
                        }))
                        } />
                }
                {
                    state.showUpdateAddressDialog &&
                    <Dialog
                        title={"Update Address"}
                        width={"35%"}
                        onClose={() => { setState(prevState => ({ ...prevState, showUpdateAddressDialog: false })) }}>
                        <div className='container-fluid'>
                            <div className='row'>
                                <BillingInformationForm
                                    initialValue={{
                                        name: state.customerStripeInfo.name,
                                        ...state.customerStripeInfo.address
                                    }}
                                    onChange={value => (
                                        dispatch({
                                            type: SET_BILLING_INFORMATION,
                                            payload: value
                                        })
                                    )}
                                />
                            </div>
                            {
                                subscriptionState.billingInformation.country === "CA" &&
                                <CompanyTaxInfoFields
                                    initialValue={
                                        state.customerStripeInfo.tax_ids.data.length > 0 ?
                                            {
                                                name: state.customerStripeInfo.name,
                                                gstNumber: state.customerStripeInfo.tax_ids?.data[0]?.value
                                            }
                                            :
                                            {}
                                    }
                                    onChange={value => (
                                        dispatch({
                                            type: SET_TAX_INFO,
                                            payload: value
                                        })
                                    )} />
                            }
                        </div>
                        <DialogActionsBar layout='end'>
                            <div className='mb-4 me-3 pe-2'>
                                <button onClick={() => { setState(prevState => ({ ...prevState, showUpdateAddressDialog: false })) }} className='btn btn-secondary'>Cancel</button>
                                <button onClick={handleBillingInformationSubmit} className='btn btn-primary'>Update</button>
                            </div>
                        </DialogActionsBar>
                    </Dialog>
                }
                {
                    state.cardToUpdate &&
                    <UpdateExpiryDialog
                        organizationId={state.currentOrganization._id}
                        paymentMethodId={state.cardToUpdate}
                        onUpdate={hideUpdateCardDialog}
                        onClose={hideUpdateCardDialog} />
                }
                {
                    state.showSubscriptionChangeDailog &&
                    <Dialog
                        title={'Change Subscription'}
                        onClose={toggleChangeSubscriptionDailog}
                    >
                        <form onSubmit={ChangeSubscription}>
                            <div className="form-label">Select Subscription</div>
                            <DropDownList
                                className="form-control-custom w-100"
                                data={state.subscriptions}
                                value={state.selectedSubscription}
                                textField="subscriptionName"
                                onChange={handleSubscriptionChange}
                            />
                            <div className="form-label">Number of seats</div>
                            <DropDownList
                                className="form-control-custom w-100"
                                data={setNumberofSeatsData()}
                                value={state.numSeats}
                                onChange={handleNumberofSeats}
                            />
                            <DialogActionsBar layout="end">
                                <small className="mt-1">
                                    {state.processingSubscription && (
                                        <div className="d-inline-block">
                                            <InnerLoader borderColor="green" />
                                            <span className="me-4 text-success"></span>
                                        </div>
                                    )}
                                </small>
                                <button
                                    onClick={toggleChangeSubscriptionDailog}
                                    type={"button"}
                                    className="btn btn-secondary mx-2">
                                    Cancel
                                </button>
                                <button
                                    type={"submit"}
                                    ref={saveBtn}
                                    disabled={shouldDisabled()}
                                    className="btn btn-primary">
                                    Change
                                </button>
                            </DialogActionsBar>
                        </form>
                    </Dialog>
                }
                {
                    state.showAddNewCardDialog &&
                    <Elements stripe={state.stripe}>
                        <AddNewCardDialog
                            organizationId={state.currentOrganization._id}
                            customerId={state.currentOrganization.stripeCustomerId}
                            onClose={hideAddNewCardDialog}
                            onCreate={handleCardAdd} />
                    </Elements>
                }
                {
                    state.showDeleteCardDialog &&
                    <RemoveDialog
                        loading={state.deletingCard}
                        toggleDeleteDialog={toggleDeleteCardDialog}
                        message="Are you sure you want to delete this card?"
                        Title="Delete card"
                        deleteButtonText="Delete"
                        onDelete={deleteCard}
                    />
                }
                {
                    state.showCancelPlanChangeDialog &&
                    <SaveDialog
                        warningIconColor='primary'
                        toggleSaveDialog={toggleCancelPlanChangeDialog}
                        message="Are you sure you want to cancel the pending change?"
                        Title="Cancel the Subscription Change"
                        SaveButtonText="Yes, Cancel the change"
                        cancelButtonText="Cancel"
                        onSave={cancelPlanChange}
                        onCancel={toggleCancelPlanChangeDialog}
                    />
                }
                {
                    state.showCancelSeatChangeDialog &&
                    <SaveDialog
                        warningIconColor='primary'
                        toggleSaveDialog={toggleCancelSeatChangeDialog}
                        message="Are you sure you want to cancel the pending change?"
                        Title="Cancel the Subscription Change"
                        SaveButtonText="Yes, Cancel the change"
                        cancelButtonText="Cancel"
                        onSave={cancelSeatChange}
                        onCancel={toggleCancelSeatChangeDialog}
                    />
                }
                {
                    state.loading ?
                        <Loader />
                        :
                        <Scrollable>
                            <div className="m-2">
                                <div className="p-3 col-md-8 border">
                                    <div className='py-3'>
                                        <div className="clearfix">
                                            <p className="float-start font-size-2">Subscription Details</p>
                                            <div className="float-end sub">
                                                <Dropdown >
                                                    <Dropdown.Toggle className='without-dropdown-arrow btn btn-sub'
                                                        variant='light'>
                                                        <i className="fa-regular fa-ellipsis" />
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item
                                                            as={"button"}
                                                            onClick={sendOpenPopupMessageToRuntime}
                                                        >
                                                            Update Subscription
                                                        </Dropdown.Item>
                                                        {
                                                            state.currentSubscription &&
                                                            state.currentSubscription.subscriptionName !== "Free" &&
                                                            <Dropdown.Item onClick={() => setState(prevState => ({
                                                                ...prevState,
                                                                showCancellationDialog: true
                                                            }))}>
                                                                Cancel Subscription
                                                            </Dropdown.Item>
                                                        }
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='py-3 font-size-1'>
                                        <h6 className='d-inline-block font-size-1'>Current Plan : </h6>
                                        <span className='txt-link mx-1'>
                                            {
                                                state.currentSubscription.length === 0 ?
                                                    "No Subscription Linked"
                                                    :
                                                    state.currentSubscription.subscriptionName
                                            }
                                            {
                                                state.currentSubscription.subscriptionName === "Free" ||
                                                    state.subscriptionStripeData?.plan?.interval === "month" ?
                                                    " - Monthly Plan"
                                                    :
                                                    " - Annual Plan"
                                            }
                                        </span>
                                        {getPlanChangeMessage()}
                                    </div>
                                    <div className='font-size-1'>
                                        <h6 className='d-inline-block font-size-1'>Number of Seats: </h6>
                                        <span className='txt-link mx-1'>
                                            {
                                                !state.currentSubscription && "No Subscription Linked"
                                            }
                                            {
                                                state.currentSubscription &&
                                                    state.currentSubscription.subscriptionName === "Free" ?
                                                    "Up to 2 seats"
                                                    :
                                                    `${state.numSeats} seats`
                                            }
                                        </span>
                                        {getSeatChangeMessage()}
                                    </div>
                                    {
                                        state.nextChargeInfo &&
                                            state.nextChargeInfo.next_payment_attempt &&
                                            state.nextChargeInfo.amount_due
                                            ?
                                            <div className='py-3 font-size-1'>
                                                <h6 className='d-inline-block font-size-1'>Next Billing: </h6>
                                                <span className='txt-link mx-1'>
                                                    {
                                                        moment(new Date(state.nextChargeInfo.next_payment_attempt * 1000)).format("Do MMMM YYYY")
                                                    }
                                                    &nbsp;
                                                    for
                                                    &nbsp;
                                                    $
                                                    {
                                                        (state.nextChargeInfo.amount_due / 100).toFixed(2)
                                                    }
                                                </span>
                                            </div>
                                            :
                                            null
                                    }
                                    <hr />
                                    <div>
                                        <div style={{ height: "200px" }}>
                                            <Scrollable>
                                                <CustomerCardList
                                                    organizationId={state.currentOrganization._id}
                                                    context={OrganizationSubscriptionContext}
                                                    CardItem={(itemProps) => (
                                                        <CardRenderer
                                                            defaultPaymentMethodId={
                                                                state.customerStripeInfo.invoice_settings?.default_payment_method
                                                            }
                                                            onUpdateCardClick={toggleUpdateExpiryDialog}
                                                            onSetAsPrimaryClick={updateCustomerPrimaryCard}
                                                            onDeleteClick={() => handleDelete(itemProps.paymentMethod.id)}
                                                            showDelete={subscriptionState.paymentMethods.length > 1}
                                                            {...itemProps}
                                                        />
                                                    )} />
                                            </Scrollable>
                                        </div>
                                        {
                                            subscriptionState.paymentMethods.length > 0 &&
                                            <button onClick={showAddNewCardDialog} className='btn btn-outline-primary mt-2'>
                                                <i className='fa-solid fa-add' /> Add new card
                                            </button>
                                        }
                                    </div>
                                    <hr />
                                </div>
                                <div>
                                    <div className="d-flex mt-5 align-items-center justify-content-between col-md-8">
                                        <h5 className='font-size-2'>
                                            Billing Information
                                        </h5>

                                        <div className="float-end sub">
                                            <Dropdown >
                                                <Dropdown.Toggle className='without-dropdown-arrow btn btn-sub float-end'
                                                    variant='light'>
                                                    <i className="fa-regular fa-ellipsis" />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>

                                                    <Dropdown.Item onClick={() => setState(prevState => ({ ...prevState, showUpdateAddressDialog: true }))}>
                                                        Edit Billing
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                    <div className='col-md-8 g-0'>
                                        <div style={{ height: "220px" }}>
                                            <Scrollable>
                                                <InvoiceList
                                                    organizationId={state.currentOrganization._id}
                                                    gridClassName='w-100'
                                                    subscriptionId={state.currentOrganization.stripeSubscriptionId}
                                                    currentPriceId={state.subscriptionStripeData?.items?.data[0]?.price.id}
                                                    onPayNowClick={handlePayNowClick} />
                                            </Scrollable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Scrollable>
                }
            </Content>
        </PageContainer>
    )
}

export default Subscription